angular.module('app')
	.controller('HomeCtrl', function (
		$scope,
		$rootScope,
		$location,
		$filter,
		HttpService,
		FactoryObj,
		$notificationService,
		$configService) {
		$scope.searching = false;
		$scope.tempAnteTextValue = null;
		$scope.orderItemList = [];
		$scope.filterTools = {
			enableFilters: false,
			limit: '6',
			pageIndex: 1,
			openSearch: '',
			offset: 0,
			totalPages: 0,
			orderColumnName: 'PRACTICE_STATUS',
			orderType: 'ASC'
		};
		$scope.mapPracticeStatus = {};
		$scope.homeIndex = 'inner-view-searchOrder';
		$scope.notificationsPerPage = 6;
		/*
			  */



		if ($rootScope.showSuccessMsg) {
			$rootScope.$broadcast('addAlert', { text: 'CONTRACT_SUBSCRIBED' });
			$rootScope.showSuccessMsg = false;
		}

		$scope.updateFakeStatus = function () {
			$scope.orderItemList[0].practiceStatus = 70;
		}

		$scope.initialize = function () {
			$scope.search();
			$scope.getPracticeStatusList();
			$scope.notificationService = $notificationService;
			$notificationService.getUserNotifications();
			console.log('$scope.notificationService: ', $scope.notificationService);
			console.log('appConfig: ', $configService.getAppConfig());
		}

		$scope.getTotalPages = function (totalCount) {
			//se il resto è zero non va aggiunto +1
			var addPlusOneToTotal = 0;
			var totModuloResult = totalCount % Number($scope.filterTools.limit);
			if (totModuloResult > 0) {
				addPlusOneToTotal = 1;
			}
			return (Math.floor(totalCount / Number($scope.filterTools.limit))) + addPlusOneToTotal;
		}

		$scope.search = function () {
			$scope.searching = true;
			var filter = {
				offset: $scope.filterTools.offset,
				limit: $scope.filterTools.limit,
				orderColumnName: $scope.filterTools.orderColumnName,
				orderType: $scope.filterTools.orderType
			};

			HttpService.send('/order/searchOrder', { appOrder: filter }, false).then(function (response) {
				$scope.searching = false;
				console.log("response", response)
				var totalCount = response.totalCount;
				//var tempItemList = response.listAppOrder;
				var tempItemList = $filter('showPracticeStatus')(response.listAppOrder, { whitelist: null, page: 'homepage' });
				$scope.filterTools.totalPages = $scope.getTotalPages(totalCount);
				$scope.orderItemList = $scope.addEmptyRow(tempItemList);
				customAnimation();
				if ($rootScope.changePracticeStatus) {
					$scope.updateFakeStatus();
					$rootScope.changePracticeStatus = false;
				} else {
				}
			});

		}

		$scope.addEmptyRow = function (restList) {
			try {
				var outputList = [];
				var indexRestList = Number($scope.filterTools.limit);
				if (restList != null) {
					outputList = restList;
					indexRestList = Number($scope.filterTools.limit) - restList.length;
				}

				if (indexRestList > 0) {
					for (var irl = 0; irl < indexRestList; irl++) {
						outputList.push({});
					}
				}
				return outputList;
			} catch (e) {
				console.error(e.message);
				return restList;
			}
		}

		$scope.pageIndexIndietro = function (value) {
			if (value == 'init') {
				$scope.filterTools.pageIndex = 1;
			} else {
				if ($scope.filterTools.pageIndex > 1) {
					$scope.filterTools.pageIndex--;
				}
			}
			$scope.updateOffsetAndSearch();
		}

		$scope.pageIndexAvanti = function (value) {
			if (value == 'end') {
				//subito pagina finale
				$scope.filterTools.pageIndex = $scope.filterTools.totalPages;
			} else {
				//avanzo +1
				if ($scope.filterTools.pageIndex < $scope.filterTools.totalPages) {
					$scope.filterTools.pageIndex++;
				}
			}
			$scope.updateOffsetAndSearch();
		}

		$scope.updateOffsetAndSearch = function () {
			$scope.filterTools.offset = ($scope.filterTools.pageIndex - 1) * $scope.filterTools.limit;
			$scope.search();
		}



		//         $scope.resumeSimulation = function(itemWf){
		//        	 FactoryObj.itemWf = itemWf;
		//        	 $rootScope.goTo('/simulator');
		//        	 //foreach per validare l'icona del menù
		//        	 $rootScope.homeIco.active = false;
		//			   angular.forEach($rootScope.menuNavBar,function(singleItem){
		//				   if(singleItem.id=='configuratore'){
		//					   singleItem.active = true;
		//				   }
		//			   })
		//
		//         }



		$scope.goToWorkInProgress = function () {
			$location.path('/workInProgress');
		}



        /**
     	 * This method is used to initialize custom simulation name and to update it.
     	 */

		$scope.updateOrderTable = function (ordColName, ordType) {
			$scope.filterTools.orderColumnName = ordColName;
			$scope.filterTools.orderType = ordType;
			$scope.search();
		}

		$scope.getPracticeStatusList = function () {
			HttpService.send('/uni/typedomain/getDomainSet', { table: 'APP_ORDER', column: 'PRACTICE_STATUS' }, false).then(function (response) {
				$scope.practiceStatusList = response.domainList;

				angular.forEach($scope.practiceStatusList, function (item) {

					if (item.value == $rootScope.propMap['POS_SCARICATO'] || item.value == $rootScope.propMap['POS_ACC_CARICATA']) {
						$scope.mapPracticeStatus[item.value] = "DA LAVORARE";
					} else if (item.value == $rootScope.propMap['POS_ERR_CARICAMENTO'] || item.value == $rootScope.propMap['POS_CARICAMENTO']) {
						$scope.mapPracticeStatus[item.value] = "IN LAVORAZIONE ALBA";
					} else {
						$scope.mapPracticeStatus[item.value] = item.name;
					}
				})
			});
		}

		$scope.goToSelectedOrder = function (idOrder) {
			FactoryObj.idSelectedOrder = idOrder;
			$rootScope.goTo('/contractDetails');
		}

		$scope.changeHomeIndex = function (innerViewName) {
			$scope.homeIndex = innerViewName;
		}


		$scope.checkArrows = function () {
			//wait for angular to add class Active to the first slide
			setTimeout(function () {
				if ($('.carousel-inner .item:first').hasClass('active')) {
					$('.up.carousel-control').hide();
					$('.down.carousel-control').show();
				} else if ($('.carousel-inner .item:last').hasClass('active')) {
					$('.up.carousel-control').show();
					$('.down.carousel-control').hide();
				} else {
					$('.carousel-control').show();
				}
			}, 0);
		}

	})
